<template>
  <div class="items-list" :key="reRenderIterator">
    <draggable v-model="queriedItemsByCategory"
               :move="dragMoved"
               ghost-class="ghost"
               :sort="true"
               tag="div"
               :animation="200"
               handle=".handle"
               dragClass="drag-item"
               @choose="onChoose"
               @unchoose="onUnchoose"
    >
      <transition-group tag="ul" name="list">
        <li v-for="category in queriedItemsByCategory" v-if="category.id" :key="category.name" v-show="category.items.length">
          <category-list-section :category="category" @sorted="onSorted"/>
        </li>
      </transition-group>
    </draggable>
  </div>
</template>

<script>
  import { mapActions, mapGetters, mapState } from 'vuex'
  import CategoryListSection from '@/components/CategoryListSection'
  import draggable from 'vuedraggable'

  export default {
    name: "ItemsList",
    components: {CategoryListSection, draggable},
    data () {
      return {
        reRenderIterator: 0
      }
    },
    computed: {
      ...mapState(['currentQuery', 'list', 'categories']),
      ...mapGetters(['userDoc', 'queriedList']),
      queriedItemsByCategory: {
        get () {
          // console.log(this.categories)
          return this.categories.map(category => ({
            ...category,
            id: category.id,
            items: this.queriedList.filter(i => i.categoryID === category.id)
          }))
        },
        set () {
          this.reRenderIterator++
        }
      }
    },
    methods: {
      ...mapActions(['setCurrentQuery', 'swapCategoryIndexes', 'setDraggingCategories']),
      onSorted () {

      },
      dragMoved ({draggedContext, relatedContext}) {
        const id1 = draggedContext.element.id
        const id2 = relatedContext.element.id

        this.swapCategoryIndexes({id1, id2})

        return true
      },
      onChoose () {
        // this.setDraggingCategories(true)
      },
      onUnchoose () {
        // this.setDraggingCategories(false)
      }
    },
    mounted () {
      this.$store.dispatch('bindList')
      this.$store.dispatch('bindCategories')
    }
  }
</script>

